import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useMapSelectionStore } from 'src/composables/useMapSelection';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConfirmModal',
  setup(__props) {

const ctx = useMapSelectionStore();

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (!!_unref(ctx).mapElem.mapDeleteConfirmElem)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        title: "削除確認",
        bottomCloseButtonLabel: "削除",
        bottomCloseButtonClass: "btn-danger",
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(ctx).doDeleteMapSelectedElem())),
        onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_unref(ctx).cancelDeleteMapSelectedElem()))
      }, {
        body: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(ctx).mapElem.mapDeleteConfirmElem?.confirmMessage), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})